__turbopack_context__.v({
  "contentWidth": "search-module-scss-module__z1CfFa__contentWidth",
  "focus": "search-module-scss-module__z1CfFa__focus",
  "freeSearchEndAdornment": "search-module-scss-module__z1CfFa__freeSearchEndAdornment",
  "fullWidth": "search-module-scss-module__z1CfFa__fullWidth",
  "isDisabled": "search-module-scss-module__z1CfFa__isDisabled",
  "numberInput": "search-module-scss-module__z1CfFa__numberInput",
  "outlined": "search-module-scss-module__z1CfFa__outlined",
  "outlinedContainer": "search-module-scss-module__z1CfFa__outlinedContainer",
  "outlinedWithoutAdornment": "search-module-scss-module__z1CfFa__outlinedWithoutAdornment",
  "underlined": "search-module-scss-module__z1CfFa__underlined",
  "underlinedContainer": "search-module-scss-module__z1CfFa__underlinedContainer",
  "underlinedWithoutAdornment": "search-module-scss-module__z1CfFa__underlinedWithoutAdornment",
});
